import { DIRECTION_LETTERS, DIRECTION_LABELS } from '../lib/courseConstants.js';

export default function CourseFilterBar({
  filters, onChange, fleets, startLocations, cardNames = [],
  startNm, finishNm, onStartNmChange, onFinishNmChange,
}) {
  const update = (key, value) => onChange({ ...filters, [key]: value });

  const hasFilters = filters.direction || filters.fleet || filters.startLocation || filters.cardName;

  return (
    <div className="filter-bar">
      <label className="filter-field">
        <span className="filter-label">Wind</span>
        <select
          value={filters.direction || ''}
          onChange={(e) => update('direction', e.target.value)}
        >
          <option value="">All directions</option>
          {DIRECTION_LETTERS.map((d) => (
            <option key={d} value={d}>{d} — {DIRECTION_LABELS[d]}</option>
          ))}
        </select>
      </label>

      {cardNames.length > 0 && (
        <label className="filter-field">
          <span className="filter-label">Course Card</span>
          <select
            value={filters.cardName || ''}
            onChange={(e) => update('cardName', e.target.value)}
          >
            <option value="">All cards</option>
            {cardNames.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
        </label>
      )}

      {fleets.length > 0 && (
        <label className="filter-field">
          <span className="filter-label">Fleet</span>
          <select
            value={filters.fleet || ''}
            onChange={(e) => update('fleet', e.target.value)}
          >
            <option value="">All fleets</option>
            {fleets.map((f) => (
              <option key={f.id} value={f.id}>{f.name || f.id}</option>
            ))}
          </select>
        </label>
      )}

      {startLocations.length > 0 && (
        <label className="filter-field">
          <span className="filter-label">Start</span>
          <select
            value={filters.startLocation || ''}
            onChange={(e) => update('startLocation', e.target.value)}
          >
            <option value="">All locations</option>
            {startLocations.map((l) => (
              <option key={l.id} value={l.id}>{l.name || l.id}</option>
            ))}
          </select>
        </label>
      )}

      <div className="filter-row">
        <label className="filter-field filter-field-narrow">
          <span className="filter-label">Start nm</span>
          <input
            type="number"
            min="0"
            max="5"
            step="0.1"
            value={startNm}
            onChange={(e) => onStartNmChange(parseFloat(e.target.value) || 0)}
          />
        </label>
        <label className="filter-field filter-field-narrow">
          <span className="filter-label">Finish nm</span>
          <input
            type="number"
            min="0"
            max="5"
            step="0.1"
            value={finishNm}
            onChange={(e) => onFinishNmChange(parseFloat(e.target.value) || 0)}
          />
        </label>
      </div>

      {hasFilters && (
        <button
          className="btn btn-sm"
          onClick={() => onChange({ direction: '', fleet: '', startLocation: '', cardName: '' })}
        >
          Clear
        </button>
      )}
    </div>
  );
}
